export const CURRENT_USER = "FIMC_CURRENT_USER";
export const EMAIL = "FIMC_EMAIL";
export const FULL_NAME = "FIMC_FULL_NAME";
export const ROLES = "FIMC_ROLES";
export const CAN_ASSIGN_DELEGATE = "FIMC_CAN_ASSIGN_DELEGATE";
export const PATRON_ROLE = "FIMC_PATRON_ROLE";
export const PATRON_SUBTYPE = "FIMC_PATRON_SUBTYPE";
